import angular from "angular";

angular
    .module('ui-sentinel.fulfillment', [
        //'ui-sentinel.api'
    ]);
